window.addEventListener('load', function() {
    (function() {
        var html, body, delay, lastScrollTop;

        html = document.querySelector('html');
        body = document.querySelector('body');
        body.dataset.scrolled = 'no';

        lastScrollTop = Math.max(html.scrollTop, body.scrollTop);

        window.addEventListener('scroll', function(event) {
            var scrollTop;

            scrollTop = Math.max(html.scrollTop, body.scrollTop);
            body.dataset.scrolled = (scrollTop > 20) ? 'yes' : 'no';

            cancelAnimationFrame(delay);

            delay = requestAnimationFrame(() => {
                var scrollTop, scrollDiff, isDown;

                isDown = null;

                scrollTop = Math.max(html.scrollTop, body.scrollTop);

                scrollDiff = scrollTop - lastScrollTop;

                if (Math.abs(scrollDiff) > 1) {
                    isDown = (lastScrollTop < scrollTop);

                    lastScrollTop = scrollTop;
                }

                ScoreTrekBattle.Event.trigger('window.scrolled', [event, scrollTop, isDown]);
            });
        });

        document.addEventListener('click', function() {
            if (!ScoreTrekBattle.Session.isAppMode()) {
                return;
            }
            window.parent.postMessage(JSON.stringify({
                type: 'event',
                event: 'iframe.clicked'
            }), '*');
        }, {capture: true});
    })();

    function showShareDialog(shareConfig) {
        if (shareConfig && shareConfig.title && shareConfig.text && shareConfig.url) {
            chmDialog.share(`<div class="copyable"><div class="copyable-text bg-color-white-10 color-white-90 p-medium">${shareConfig.title}<br><br>${shareConfig.text}<br>${shareConfig.url}</div><div class="mt-medium"><span class="text-link" data-trigger-action="copy"><i class="fa-solid fa-copy"></i> <span>${__i18n('button/copy')}</span></span></div></div>`);
        }
    }

    function setEnvironment(env) {
        if (env === 'live') {
            return;
        }

        if (env === 'stage') {
            env = 'beta';
        }

        document.title = `${env.toUpperCase()} ${document.title}`;

        $('.environment').remove();

        if (!ScoreTrekBattle.Session.isAppMode()) {
            ScoreTrekBattle.$body.append(`<div class="environment" data-env="${env}">${env.toUpperCase()}</div>`);
        }
    }

    function setDynamicStyles() {
        let $style;

        $style = $('<style>').attr('type', 'text/css').text([
            `:root {`,
                `--placeholder-club: url('${ScoreTrekBattle.ASSETS.PLACEHOLDER.club}');`,
            `}`
        ].join(''));

        $('head').append($style);

    }

    ScoreTrekBattle.$htmlBody = $('html,body');
    ScoreTrekBattle.$body = $('body');
    ScoreTrekBattle.$body.children(':not(script)').remove();
    ScoreTrekBattle.$body.removeClass('preboot');

    function showConnectionErrorAndRetry() {
        chmDialog({
            title: __i18n('dialog/simple/error'),
            content: __i18n('error/noConnectionToServer'),
            isPersistant: true,
            buttons: [
                {
                    label: __i18n('button/retry'),
                    icon: '<i class="fa-solid fa-arrows-rotate"></i>',
                    primary: true,
                    action: function() {
                        location.reload();
                    }
                }
            ]
        });
    }

    ScoreTrekBattle.View.loading('initialLoad', true);

    Api.request('/battle/config').then(result => {
        if (result && result.config) {
            ScoreTrekBattle.CONFIG = result.config;
        } else {
            showConnectionErrorAndRetry();
            return;
        }

        return Promise.all([
            ScoreTrekBattle.Template.render('layout/header'),
            ScoreTrekBattle.Template.render('layout/nav'),
            ScoreTrekBattle.Template.render('layout/main')
        ]).then(views => {
            views.forEach(view => {
                ScoreTrekBattle.$body.append(view.$view);
            });

            ScrollHandler.activate('#refreshIndicator', null, {
                delay: 1500,
                beforePulledToRefresh: function () {
                    ScoreTrekBattle.View.loadingBackground('pulledToRefresh', true);
                },
                afterPulledToRefresh: function () {
                    ScoreTrekBattle.View.loadingBackground('pulledToRefresh', false);
                }
            });

            ScoreTrekBattle.Session.renderClubList(views[2]);

            ScoreTrekBattle.$main = ScoreTrekBattle.$body.find('main').first();

            ScoreTrekBattle.Event.on('action.mainMenu.toggle', function(event) {
                event.stopPropagation();
                ScoreTrekBattle.Event.trigger('root.click');
                ScoreTrekBattle.$body.toggleClass('mainMenu-minimized');
            });

            ScoreTrekBattle.Event.on('action.profileMenu.toggle', function(event) {
                event.stopPropagation();
                ScoreTrekBattle.Event.trigger('root.click');
                ScoreTrekBattle.$body.toggleClass('profileMenu-visible');
            });

            ScoreTrekBattle.Event.on('action.dialog.close', function(event) {
                chmDialog.close();
            });

            ScoreTrekBattle.Event.on('root.click', function() {
                ScoreTrekBattle.$body.removeClass('profileMenu-visible');
                ScoreTrekBattle.$body.find('.subMenu-visible').removeClass('subMenu-visible');
                ContextMenu.closeAll();
            });

            ScoreTrekBattle.Event.on('session.ready', function(isAuthenticated) {
                ScoreTrekBattle.View.init('dashboard');
            });

            ScoreTrekBattle.Event.on('session.login', function() {
                ScoreTrekBattle.View.reload();
            });

            ScoreTrekBattle.Event.on('session.logout', function() {
                if (!ScoreTrekBattle.Session.isAppMode()) {
                    ScoreTrekBattle.View.goto('/dashboard', true);
                }
            });

            ScoreTrekBattle.Event.on('action.share', function(event, shareType, refId) {
                var shareConfig;

                shareConfig = {
                    title: 'Score Trek Battle',
                    dialogTitle: 'Score Trek Battle',
                    text: __i18n(`share/text`, {
                        refName: ScoreTrekBattle.Settings.getShareRefName(shareType, refId)
                    }),
                    url: ScoreTrekBattle.Settings.getShareUrl(shareType, refId)
                };

                if (ScoreTrekBattle.Session.isAppMode()) {
                    window.parent.postMessage(JSON.stringify({
                        type: 'event',
                        event: 'iframe.share',
                        data: shareConfig
                    }), '*');
                } else if (navigator.share) {
                    navigator.share(shareConfig).catch(() => {
                        showShareDialog(shareConfig);
                    });
                } else {
                    showShareDialog(shareConfig);
                }
            });

            ScoreTrekBattle.Event.on('action.favorite', function(event, favoriteType, refId) {
                let favoriteKey;

                if (!ScoreTrekBattle.Session.hasPlayer()) {
                    ScoreTrekBattle.Session.showLoginNotice();
                    return;
                }

                favoriteKey = `favorite.${favoriteType || ''}.${refId || ''}`;

                ScoreTrekBattle.View.loadingBackground(`Favorite.toggle.${favoriteKey}`, true);
                Api.request('/battle/favorite/toggle', {
                    type: favoriteType,
                    refId: refId
                }).then(result => {
                    if (!result.hasOwnProperty('isFavorite')) {
                        return;
                    }

                    ScoreTrekBattle.Settings.toggleFavorite(favoriteType, refId, result.isFavorite);
                }).catch(ignore => {}).finally(() => {
                    ScoreTrekBattle.View.loadingBackground(`Favorite.toggle.${favoriteKey}`, false);
                });
            });

            ScoreTrekBattle.Event.on('action.calendar', function(event, eventType, refId, provider) {
                FileManager.openWindow(
                    `${ScoreTrekBattle.ENV.API}battle/calendar/${eventType}/${refId}/${provider}`,
                    __i18n('calendar/dialog/title'),
                    __i18n('calendar/dialog/text'),
                    __i18n('calendar/dialog/button'),
                    '<i class="fa-solid fa-calendar-plus"></i>'
                );
            });

            ScoreTrekBattle.Event.on('app.to.battle.share', function(shareConfig) {
                showShareDialog(shareConfig);
            });

            ScoreTrekBattle.Event.on('app.to.battle.useContextMenu', function(data) {
                chmContextMenu.init(
                    function(text) {
                        return chmClipboard.copy(text);
                    },
                    function() {
                        return chmClipboard.paste();
                    },
                    {
                        cut: __i18n('button/cut'),
                        copy: __i18n('button/copy'),
                        paste: __i18n('button/paste')
                    }
                );
            });

            ScoreTrekBattle.Event.on('action.copy', function() {
                var $trigger, text;
                $trigger = $(this).removeClass('color-green color-red');
                text = $('<div>').html($trigger.closest('.copyable').find('.copyable-text').html().split('<br>').join('\n')).text().trim();
                chmClipboard.copy(text).then(() => {
                    $trigger.addClass('color-green');
                }).catch(() => {
                    $trigger.addClass('color-red');
                }).finally(() => {
                    AnimationHandler.pulse($trigger).then(() => {
                        $trigger.removeClass('color-green color-red');
                    });
                });
            });

            ScoreTrekBattle.Event.on('action.none', function() {
            });

            if (window !== top) {
                ScoreTrekBattle.Session.appMode(true);
            }

            setEnvironment(ScoreTrekBattle.ENV.NAME || 'beta');

            setDynamicStyles();

            ScoreTrekBattle.Event.trigger('action.session.restore');
        });
    }).catch(() => {
        showConnectionErrorAndRetry();
    }).finally(() => {
        ScoreTrekBattle.View.loading('initialLoad', false);
    });
});